var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section3 d-none d-lg-block"},[_c('canvas',{ref:"canvas",attrs:{"width":"1920px","height":"1080px"},on:{"mouseout":function($event){return _vm.canvasMouseout()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }